/* jshint esversion: 6 */

//TODO: show console statements for careers page
import "bootstrap/dist/css/bootstrap.css";
import "select2/dist/css/select2.css";
import { isIE9 } from "./components/helpers";

const $ = require("jquery");
// const pace = require('./vendors/Pace');
import plyr from "plyr";
import DJAX from "./components/djax";
import HeaderMenu from "./components/header-menu";
import InstafeedSlider from "./components/instafeedSlider";
import contactScroll from "./components/scrolling/contact-scroll";
import meetingsScroll from "./components/scrolling/meetings-scroll";
import ServicesScroll from "./components/scrolling/services-scroll";
import {
  default as AboutScroll,
  default as TeamScroll,
} from "./components/scrolling/team-scroll";
import VacancyScroll from "./components/scrolling/vacancy-scroll";
import workScroll from "./components/scrolling/work-scroll";
import VirtualScrollFactory from "./components/verticalScrollFactory";

var HorizontalScroll =
  require("./components/scrolling/horizontal-scroll").default;

require("icheck");
require("select2/dist/js/select2");

import { MatchHeight, detectBrowser, makeLabel } from "./components/helpers";

__webpack_public_path__ = `${CCM_APPLICATION_URL}/application/themes/tentwenty/js/dist/`;

class Bootstrap {
  constructor() {
    detectBrowser();

    this.el = $("html, body");
    this.el.matchHeightEl = this.el.find(".js-height");
    window.smoothScrollInstances = [];
    this.el.chatPage = $(".chat-page");
    this.el.chatPage.find(".lets-chat").addClass("fade-in");
    this.el.chatPageRows = this.el.chatPage.find(".formidable_row");
    this.el.loader = $("#siteLoader");
    this.el.formidableSubmit = $(".formidable form");

    setTimeout(() => {
      this.el.loader.addClass("loaded");

      setTimeout(() => this.el.loader.remove(), 1000);
    }, 2000);

    // call class functions
    ["initPluginsForAJAX", "initPersistentPlugins", "resize"].forEach((fn) =>
      this[fn].apply(this)
    );

    $(window).on("resize", this.resize.bind(this));

    if (this.el.chatPageRows.length) {
      const buttonRow = this.el.chatPage
        .find(".element.form-group.form-actions")
        .closest(".formidable_row");
      this.el.chatPageRows
        .last()
        .addClass("last-row")
        .siblings()
        .find(".formidable_column")
        .children()
        .addClass("vertical-align-center")
        .wrap('<div class="vertical-align-block"></div>');
      this.el.chatPage
        .find(".element.form-group.your-message-18")
        .after(
          this.el.chatPage
            .find("#ff_buttons")
            .closest(".element.form-group.form-actions")
        );
      // ratingButtons.html(ratingButtons.find('input[type=radio]'));
      $(window).trigger("resize");

      this.el.chatPage.find("#submit").on("click", (e) => {
        let times = 0;
        const timer = setInterval(() => {
          times++;
          $(window).trigger("resize");

          if (times === 10) {
            clearInterval(timer);
          }
        }, 400);
      });
    }

    if (isIE9()) {
      this.el.addClass("ie9");
    }

    $(document).on("mousemove", (e) => (window.mouseXPos = e.clientX));
  }

  initPersistentPlugins() {
    new HeaderMenu();
    new DJAX(this.initPluginsForAJAX.bind(this));
  }

  initPluginsForAJAX(url = null) {
    this.el.matchHeightEl = this.el.find(".js-height");
    this.resize.call(this);

    const homePageScroll = $(".vs-section.HS-home"),
      servicesScroll = $(".services-scroll"),
      verticalScroll = $(".vertical-virtual-scroll"),
      aboutPage = $(".about-scroll"),
      teamPage = $(".team-scroll"),
      meetingsPage = $(".meeting-page"),
      contactPage = $(".contact-page-overview"),
      workPage = $(".work-scroll"),
      vacancyPage = $(".vacancy-page"),
      formidableFeilds = $(".formidable input, .formidable textarea").not(
        ":hidden, [type=submit]"
      ),
      checkboxes = $("input[name*='choose-your-beverage']"),
      instafeed = $("#instafeed"),
      isInstafeedBlog = $("#instafeed").hasClass("blog__instafeed"),
      select = $("select"),
      blogSlider = $(".blog__slider"),
      blogVideos = $(".blog__videos");

    checkboxes.iCheck();

    makeLabel(formidableFeilds);

    select.select2({
      minimumResultsForSearch: Infinity,
    });
    if (blogVideos.length) {
      console.log(blogVideos);
      const videoPlayers = blogVideos.map(
        (index, videoParent) => videoParent.getElementsByTagName("video")[0]
      );
      const playing = plyr.setup(videoPlayers, {
        autoplay: true,
        loop: true,
        controls: ["play", "volume", "progress"],
      });
    }
    if (blogSlider.length) {
      if (!blogSlider.children().length) {
        blogSlider.parent().css("margin", 0);
      } else {
        blogSlider.slick({
          draggable: true,
          arrows: true,
          // fade: true,
          prevArrow:
            '<a class="prev vacancy__link no-barba" ><span class="icon-arrow-back"></span>Previous</a>',
          nextArrow:
            '<a class="vacancy__link no-barba" >Next <span class="icon-arrow-front"></span></a>',
          speed: 700,
          infinite: true,
          touchThreshold: 100,
          slidesToShow: 1,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    }

    if (homePageScroll.length) {
      // require.ensure(['./components/scrolling/horizontal-scroll'], (require) => {
      //     var HorizontalScroll = require('./components/scrolling/horizontal-scroll').default;
      setTimeout(() => {
        var hr = new HorizontalScroll({
          preload: false,
          native: false,
          noscrollbar: true,
          direction: "horizontal",
          ease: 0.06,
          url,
          section: homePageScroll[0],
          divs: homePageScroll.find(".pages-container .page"),
          pageContainerFront: homePageScroll.find(
            ".pages-container.container--front"
          )[0],
          pageContainerBack: homePageScroll.find(
            ".pages-container.container--back"
          )[0],
          header: this.el.find("header .hamburger button")[0],
          logo: this.el.find("header .logo")[0],
          scrollAmount: window.outerWidth / 4,
          useDrag: true,
        });

        hr.init();
        url === null && hr.off();
      }, 20);
      // });
    }

    if (servicesScroll.length) {
      //   require.ensure(["./components/scrolling/services-scroll"], (require) => {
      //     const ServicesScroll =
      //       require("./components/scrolling/services-scroll").default;
      //     new ServicesScroll(servicesScroll);
      //   });
      new ServicesScroll(servicesScroll);
    }

    if (verticalScroll.length && !url) new VirtualScrollFactory(verticalScroll);

    if (contactPage.length) {
      //   require.ensure(["./components/scrolling/contact-scroll"], (require) => {
      //     const contactScroll =
      //       require("./components/scrolling/contact-scroll").default;
      //     new contactScroll(contactPage);
      //   });
      new contactScroll(contactPage);
    }

    if (aboutPage.length) {
      //   require.ensure(["./components/scrolling/about-scroll"], (require) => {
      //     const AboutScroll =
      //       require("./components/scrolling/about-scroll").default;
      //     new AboutScroll(aboutPage);
      //   });
      new AboutScroll(aboutPage);
    }

    if (teamPage.length) {
      //   require.ensure(["./components/scrolling/team-scroll"], (require) => {
      //     const TeamScroll =
      //       require("./components/scrolling/team-scroll").default;
      //     new TeamScroll(teamPage);
      //   });

      new TeamScroll(teamPage);
    }

    if (workPage.length) {
      //   require.ensure(["./components/scrolling/work-scroll"], (require) => {
      //     const workScroll =
      //       require("./components/scrolling/work-scroll").default;
      //     new workScroll(workPage);
      //   });
      new workScroll(workPage);
    }

    if (meetingsPage.length) {
      //   require.ensure(["./components/scrolling/meetings-scroll"], (require) => {
      //     const meetingsScroll =
      //       require("./components/scrolling/meetings-scroll").default;
      //     new meetingsScroll(meetingsPage);
      //   });
      new meetingsScroll(meetingsPage);
    }

    if (vacancyPage.length) {
      // require.ensure(['./components/scrolling/vacancy-scroll'], (require) => {
      //     const VacancyScroll = require('./components/scrolling/vacancy-scroll').default;
      //     new VacancyScroll(vacancyPage);
      // });
      new VacancyScroll(vacancyPage);
      if (
        $(".addthis-smartlayers").length &&
        $(".addthis-smartlayers").parent().find(".page-type-blog").length
      ) {
        $("#at4-share").css("z-index", "auto");
      }
    }

    if (instafeed.length) {
      // require.ensure(['./components/instafeedSlider.js'], (require) => {
      //     const instafeedSlider = require('./components/instafeedSlider').default;
      //     new instafeedSlider(instafeed, isInstafeedBlog);
      // });
      new InstafeedSlider(instafeed, isInstafeedBlog);
    }
  }

  hijackVirtualScroll() {
    $(document)
      .on("focus", "input, textarea", () => {
        if (!window.smoothScrollInstances.length) return;
        window.smoothScrollInstances[0].off();
      })
      .on("blur", "input, textarea", () => {
        if (!window.smoothScrollInstances.length) return;
        window.smoothScrollInstances[0].on();
      });
  }

  resize() {
    MatchHeight(this.el.matchHeightEl);

    if (this.el.chatPage.length) {
      const columns = this.el.chatPageRows.first().find(".formidable_column");
      columns.height("auto");
      if (window.innerHeight > columns.height()) {
        columns.height($(window).innerHeight());
      } else {
        MatchHeight(this.el.chatPageRows.first());
      }
    }
  }
}

(function () {
  var lastTime = 0;
  var vendors = ["ms", "moz", "webkit", "o"];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
    window.cancelAnimationFrame =
      window[vendors[x] + "CancelAnimationFrame"] ||
      window[vendors[x] + "CancelRequestAnimationFrame"];
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function (callback, element) {
      var currTime = +new Date();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      lastTime = currTime + timeToCall;
      return window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
})();

if (document.body.className.indexOf("page-home") > -1) {
  setTimeout(function () {
    var loaded = false;
    const animation = window.animation;

    window.onload = () => (loaded = true);

    const element = document.getElementById("loaderAnimation");

    if (!animation) {
      new Bootstrap();
      element.style.display = "none";
      return false;
    }

    animation.removeEventListener("enterFrame");

    animation.addEventListener("enterFrame", (x) => {
      if (x.currentTime >= 100) {
        bodymovin.setSpeed(0.5, "introAnim");

        if (x.currentTime >= 110) {
          bodymovin.pause("introAnim");
          animation.removeEventListener("enterFrame");

          if (loaded) {
            documentLoaded();
          } else {
            window.onload = documentLoaded();
          }
        }
      }
    });

    bodymovin.play("introAnim");

    function documentLoaded() {
      new Bootstrap();
      animation.addEventListener("complete", (x) => {
        $(element)
          .addClass("loader-animation--hide")
          .one("transitionEnd", function () {
            $(this).remove();
            animation.destroy();
          });
      });

      bodymovin.setSpeed(1, "introAnim");
      bodymovin.play("introAnim");
    }
  }, 200);
} else {
  window.onload = function () {
    var element = document.getElementById("loaderAnimation");
    const animation = window.animation;

    if (!animation) {
      new Bootstrap();
      element.style.display = "none";
      return false;
    }

    bodymovin.setSpeed(1, "introAnim");
    bodymovin.play("introAnim");
    animation.removeEventListener("enterFrame");

    animation.addEventListener("complete", (x) => {
      element.className = element.className + " loader-animation--hide";
      setTimeout(function () {
        element.style.display = "none";
      }, 300);
      animation.destroy();
    });

    setTimeout(function () {
      new Bootstrap();
    }, 1000);
  };
}

window.firstLoad = true;



// WEBPACK FOOTER //
// ./app/index.js